import axiosInstance from "../axios";

class ExerciseDataService {
  get(id: any, ui: string) {
    return axiosInstance.get(`/${ui}/exercises/${id}`);
  }
}

export default new ExerciseDataService();
